import { render, staticRenderFns } from "./Campaigns.vue?vue&type=template&id=6f1b9d2f&"
import script from "./Campaigns.vue?vue&type=script&lang=ts&"
export * from "./Campaigns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports